.loading-overlay {
  display: flex;
  position: absolute;
  z-index: 1;
  align-items: center;
  justify-content: center;
  background: color-mix(in srgb, var(--rc-calendar-color-surface-subtle) 50%, transparent);
  inset: 0;
}
